<div class="calendar-header">
	<div class="calendar-navigation">
		<div class="datepicker-button">
			<button md-button (click)="toggleDatePicker()">
				<md-icon>keyboard_arrow_down</md-icon>
			</button>
			<md-date-picker [selectedDates]="[initDate()]" (change)="setDate($event)" [ngClass]="{ active: datePickerActive() }"></md-date-picker>
		</div>
		<div class="calendar-month-year">
			<div class="month">{{ monthName() }}</div>
			<div class="year">{{ yearName() }}</div>
		</div>
		<div class="navigation-buttons">
			<button md-button-link (click)="previousWeek()">
				<md-icon>chevron_left</md-icon>
			</button>
			<button md-button-link (click)="nextWeek()">
				<md-icon>chevron_right</md-icon>
			</button>
		</div>
		<button md-button (click)="setToday()">Today</button>
	</div>

	@if (calendarConfig().calendarHeaderActionsAreaComponent) {
		<div class="calendar-header-actions-area">
			<ng-container
				*ngComponentOutlet="calendarConfig().calendarHeaderActionsAreaComponent!; inputs: calendarConfig().calendarHeaderActionsAreaComponentInputs"
			></ng-container>
		</div>
	}
</div>

<div class="calendar-days">
	<div class="day-header">
		@if (calendarConfig().timezoneInfo && calendarConfig().timezoneInfo!().show) {
			<div class="timezone-info">
				<small>{{ calendarConfig().timezoneInfo!().abbreviation }}</small>
			</div>
		}
	</div>
	@for (date of daysOfWeek(); track date.format) {
		<div class="day-header">
			<ng-container *ngComponentOutlet="calendarConfig().dateHeaderComponent!; inputs: { date }"></ng-container>
		</div>
	}
</div>

<div class="calendar-body">
	<div class="calendar-column"></div>
	@for (day of daysOfWeek(); track day.format; let index = $index; let last = $last) {
		<div class="calendar-column" [ngStyle]="{ 'grid-column': index + 2 }" [ngClass]="{ 'last-column': $last }" [attr.data-day-of-week]="day.format"></div>
	}

	@for (time of timesOfDay(); track time.id; let index = $index; let last = $last) {
		<div
			class="calendar-row"
			[ngStyle]="{ 'grid-row': index + 1 }"
			[ngClass]="{ 'last-row': $last }"
			[attr.data-grid-row]="index + 1"
			[attr.data-hour-of-day]="time.hour"
			[attr.data-minute-of-hour]="time.minute"
		></div>
	}

	@for (time of timesOfDay(); track time.id; let index = $index; let last = $last) {
		<div class="time-cell" [ngStyle]="{ 'grid-row': index + 1 }">{{ $odd && this.calendarConfig().skipOdd ? '' : time.label }}</div>
	}

	@for (event of eventsAdjusted(); track event.eventID; let index = $index) {
		<div
			class="event"
			[ngStyle]="{
				'grid-row-start': event.gridRowStart,
				'grid-row-end': event.gridRowEnd,
				'grid-column-start': event.gridColumnStart,
				'grid-column-end': event.gridColumnEnd
			}"
		>
			<ng-container *ngComponentOutlet="event.component!; inputs: event.inputs ? event.inputs(event, index) : { event, index }"></ng-container>
		</div>
	}
</div>
